export default "__VITE_ASSET__Dtjqdvxt__"